<template>
    <v-main>
        <v-container fluid fill-height>
            <router-view></router-view>
        </v-container>
    </v-main>
</template>

<script>

import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RecoveryWrapper extends Vue
{
    //
};
</script>